const translations = {
    fr: {
      loadingError: "Erreur : Impossible de récupérer les données",
      startButton: "C'est parti !",
      endButton: "Retour à l'accueil"
    },
    en: {
      loadingError: "Error: Unable to retrieve data",
      startButton: "Let's go!",
      endButton: "Back to home"
    },
    de: {
      loadingError: "Fehler: Daten konnten nicht abgerufen werden",
      startButton: "Los geht’s!",
      endButton: "Zurück zur Startseite"
    },
    es: {
      loadingError: "Error: No se pudieron recuperar los datos",
      startButton: "¡Vamos!",
      endButton: "Volver al inicio"
    },
    it: {
      loadingError: "Errore: impossibile recuperare i dati",
      startButton: "Si parte!",
      endButton: "Torna alla home"
    }
  };
  
  export default translations;
  